import { useTranslation } from 'react-i18next';

import { Typography as MuiTypography } from '@mui/material';

import { Icon } from 'components/ui';

import {
  SClearFilterButton,
  SContainer,
  SFilterBody,
  SFilterHeader,
} from './styled';

export default function FiltersSidebar({
  filters,
  setFilters,
  resetFilters,
  children,
}) {
  const { t } = useTranslation();

  return (
    <SContainer>
      <SFilterHeader>
        <MuiTypography variant="h5">{t('Filter')}</MuiTypography>
        <SClearFilterButton color="error" onClick={resetFilters}>
          <Icon icon="trash-alt" className="icon" mr={10} />
          {t('Clear filter')}
        </SClearFilterButton>
      </SFilterHeader>
      <SFilterBody>{children}</SFilterBody>
    </SContainer>
  );
}
